import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { vacancyService, placementDriveService } from '../../services/api';
import { getUserData } from '../../utils/auth';
import './CompanyPostVacancy.css';

function CompanyPostVacancy() {
  const location = useLocation();
  const preselectedDriveId = location.state?.driveId;
  const userData = getUserData();
  const companyId = userData?.companyId || userData?.CompanyId;

  const [drives, setDrives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Title: '',
    Description: '',
    Conditions: '',
    Question1: '',
    Question2: '',
    Question3: '',
    LastDate: '',
    PlacementDriveId: preselectedDriveId || '',
  });

  useEffect(() => {
    loadDrives();
  }, []);

  useEffect(() => {
    if (preselectedDriveId) {
      setFormData((prev) => ({ ...prev, PlacementDriveId: preselectedDriveId }));
    }
  }, [preselectedDriveId]);

  const loadDrives = async () => {
    try {
      const data = await placementDriveService.GetNewPlacementDrives();
      setDrives(data);
    } catch (error) {
      alert('Error loading placement drives: ' + error.message);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!companyId) {
      alert('Company session not found. Please log in again.');
      return;
    }
    if (!formData.PlacementDriveId) {
      alert('Please select a placement drive.');
      return;
    }
    try {
      setLoading(true);
      await vacancyService.saveVacancy({
        ...formData,
        CompanyId: companyId,
        CordinatorId: null,
      });
      alert('Vacancy posted successfully!');
      setFormData({
        Title: '',
        Description: '',
        Conditions: '',
        Question1: '',
        Question2: '',
        Question3: '',
        LastDate: '',
        PlacementDriveId: preselectedDriveId || '',
      });
    } catch (error) {
      alert('Error saving vacancy: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="company-post-vacancy">
      <div className="page-header">
        <div className="container">
          <h1>Post Vacancy</h1>
          <p>Post a new vacancy on a placement drive</p>
        </div>
      </div>
      <div className="container">
        <form className="vacancy-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Placement Drive *</label>
            <select
              name="PlacementDriveId"
              value={formData.PlacementDriveId}
              onChange={handleChange}
              required
            >
              <option value="">Select placement drive</option>
              {drives.map((d) => (
                <option key={d.Id} value={d.Id}>{d.Title}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Job Title *</label>
            <input
              type="text"
              name="Title"
              value={formData.Title}
              onChange={handleChange}
              required
              placeholder="e.g. Software Engineer"
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              name="Description"
              value={formData.Description}
              onChange={handleChange}
              rows={4}
              placeholder="Job description"
            />
          </div>
          <div className="form-group">
            <label>Conditions / Eligibility</label>
            <textarea
              name="Conditions"
              value={formData.Conditions}
              onChange={handleChange}
              rows={3}
              placeholder="Eligibility criteria"
            />
          </div>
          <div className="form-group">
            <label>Question 1 (for applicants)</label>
            <input
              type="text"
              name="Question1"
              value={formData.Question1}
              onChange={handleChange}
              placeholder="Optional question for applicants"
            />
          </div>
          <div className="form-group">
            <label>Question 2</label>
            <input
              type="text"
              name="Question2"
              value={formData.Question2}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Question 3</label>
            <input
              type="text"
              name="Question3"
              value={formData.Question3}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Application Last Date</label>
            <input
              type="date"
              name="LastDate"
              value={formData.LastDate}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Posting...' : 'Post Vacancy'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CompanyPostVacancy;
